import React from 'react'
import styles from './BaseCard.module.css'

export const BaseCard = ({ title, iconSrc, ...props }) => {
    return (
        <div className={styles.baseCard} {...props}>
            <div className={styles.iconWrapper}>
                {iconSrc && <img src={iconSrc} alt={title} className={styles.cardIcon} />}
            </div>
            <p className={styles.cardText}>{title}</p>
        </div>
    )
}

export default BaseCard
